export default "__VITE_ASSET__esHWr11$__"